import { extrasSelector as extrasDataSelector } from '../extras/selectors';
import {
  amountPaidSelector,
  depositSelector,
  depositAvailableSelector,
  totalCostSelector as totalCostBookingSelector,
  typeSelector,
  unitPriceSelector,
  discountValueSelector,
  paidWithFullVoucherSelector,
  isEuroBookingSelector,
} from '../booking/selectors';
import { getRequestStatus } from '../../requests/selectors';

import { SET_PARTY_DETAILS } from './action-types';

export const detailsSelector = (state) => state.booking.form.details;
export const offersSelector = (state) => state.booking.form.offers;
export const partySelector = (state) => state.booking.form.party;

// Extras
export const extrasSelector = (state) => state.booking.form.extras;
// All available extras
export const extrasWithValuesSelector = (state) => {
  return extrasDataSelector(state)?.map((extra) => {
    const value = extrasSelector(state)[extra.code] || 0;
    const totalCost = parseFloat(extra.cost) * value;
    const totalDepcost = parseFloat(extra.depcost) * value;
    return { ...extra, value, totalCost, totalDepcost };
  });
};

// Extras the user has selected
export const selectedExtrasWithValuesSelector = (state) => {
  return extrasWithValuesSelector(state)?.filter((extra) => extra.value > 0);
};

// Returns total additional deposit of selected extras (cancellation protection)
export const selectedExtrasDepositTotalSelector = (state) => {
  return extrasWithValuesSelector(state)?.reduce((total, extra) => {
    return extra.totalDepcost + total;
  }, 0);
};

// Returns total cost of all selected extras (cancellation protection)
export const selectedExtrasTotalSelector = (state) => {
  return extrasWithValuesSelector(state)?.reduce((total, extra) => {
    return extra.totalCost + total;
  }, 0);
};

// Party
export const partyValuesSelector = (state) => state.booking.form.party.values;
export const [partyIsSavingSelector, partyHasSaveErrorSelector, partySaveErrorSelector] =
  getRequestStatus(SET_PARTY_DETAILS);

// Payment
export const paymentSelector = (state) => state.booking.form.payment;
export const paymentOptionSelector = (state) => state.booking.form.payment.paymentOption;

// Total cost
export const remainingBalanceSelector = (state) => {
  const _totalCost = +(totalCostBookingSelector(state) || 0);
  const _amountPaid = +(amountPaidSelector(state) || 0);
  return _totalCost - _amountPaid;
};

export const totalCostDepositSelector = (state) => {
  const _deposit = depositSelector(state) || 0;
  return parseFloat(_deposit) + selectedExtrasDepositTotalSelector(state);
};

export const totalCostFullSelector = (state) => {
  const _unitPrice = unitPriceSelector(state) || 0;
  const _discountValue = discountValueSelector(state) || 0;
  return parseFloat(_unitPrice - _discountValue) + selectedExtrasTotalSelector(state);
};

export const totalCostSelector = (state) => {
  const _depositAvailable = depositAvailableSelector(state);
  const _paymentOption = paymentOptionSelector(state);
  const paidWithFullVoucher = paidWithFullVoucherSelector(state);
  const isEuroBooking = isEuroBookingSelector(state);

  if (isEuroBooking && paidWithFullVoucher) return 0;

  return _depositAvailable && _paymentOption === 'deposit'
    ? totalCostDepositSelector(state)
    : totalCostFullSelector(state);
};

export const totalCostRemainingSelector = (state) => {
  const _bookingType = typeSelector(state);
  if (_bookingType === 'new') {
    return totalCostFullSelector(state) - totalCostSelector(state);
  }
  return remainingBalanceSelector(state);
};

export const paymentAmountSelector = (state) => {
  const _bookingType = typeSelector(state);
  if (_bookingType === 'new') {
    return paymentOptionSelector(state) === 'full' ? totalCostFullSelector(state) : totalCostDepositSelector(state);
  }
  return remainingBalanceSelector(state);
};
